import Vue from 'vue';
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

const containsKey = (obj, key) => Object.keys(obj).includes(key);

export async function login({ commit }, Data) {
  const token = btoa(Data.userId + ':' + Data.userPass);
  var to_Response = {};
  commit('cleanErrors');
  await Vue.axios({
    method: 'POST',
    url: '/auth/',
    headers: {
      Authorization: 'Basic ' + token,
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      if (containsKey(response.data, 'access_token')) {
        commit('setAccesToken', response.data['access_token']);
        commit('setRefreshToken', response.data['refresh_token']);
        // commit("setUserIsLogged",true)
        commit('setUserType', response.data['type']);
        commit('setUserData', response.data['profile_data']);
        // if (response.data["type"] != "parent") {
        //   to_Response["first"] =
        //     response.data["profile_data"].moduleFocusOn == null;
        //   commit("themeChange", response.data["profile_data"].themeSelection);
        // }
        to_Response['logged'] = true;
      }
    })
    .catch(function(error) {
      if (error.response.status == 403) {
        commit('registerError', error.response.data);
      } else {
        commit('registerError', 'An error has occurred. Please reload the page again.');
        commit('logout');
      }
      to_Response['logged'] = false;
    });
  return to_Response;
}

export async function getUserData({ commit }, data) {
  await Vue.axios({
    method: 'GET',
    url: `/${data.userIsAparent ? 'parent' : 'child'}/${data.userId}/`,
  })
    .then((response) => {
      commit('setUserData', response.data);
    })
    .catch((error) => {
      commit('error', error.message);
    });
}

export async function logout({ commit }) {
  commit('logout');
  return true;
}

export async function passwordRecovery({ commit }, email) {
  await Vue.axios({
    method: 'POST',
    url: '/password-recovery/',
    data: {
      email: email,
    },
  })
    .then((response) => {
      console.log(response);
    })
    .catch((error) => {
      commit('registerError', error.message);
    });
}

export async function refreshToken({ commit }) {
  Vue.$cookies.remove('token');
  var r_token = Vue.$cookies.get('refresh');
  await Vue.axios({
    method: 'POST',
    url: '/refresh/',
    data: {
      refresh_token: r_token,
    },
  })
    .then((response) => {
      if (containsKey(response.data, 'access_token')) {
        commit('setAccesToken', response.data['access_token']);
      }
      return true;
    })
    .catch((error) => {
      commit('registerError', error.message);
    });
}

export async function parentConfigureNotifications({ commit }, data) {
  await Vue.axios({
    method: 'POST',
    url: `/parent/${data.id}/notification_setup/`,
    data: {
      has_email_notifications: data.email,
      daily_family_report: data.report || false,
      daily_family_report_time: data.time,
    },
  })
    .then((response) => {
      console.log('response', response);
    })
    .catch((error) => {
      commit('error', error.message);
    });
}

export async function parentGetNotificationsStup({ commit }, userId) {
  await Vue.axios({
    method: 'GET',
    url: `/parent/${userId}/notification_setup/`,
  })
    .then((response) => {
      commit('saveNotificationSetup', response.data);
    })
    .catch((error) => {
      commit('error', error.message);
    });
}

export async function registerChild({ commit }, data) {
  let _response = false;
  try {
    await Vue.axios({
      method: 'POST',
      url: `/register/child/`,
      data: {
        name: data.name,
        last_name: data.last_name,
        birthdate: data.birthdate,
        parent: data.parent,
      },
    })
      .then((response) => {
        // return child id
        _response = response.data.id;
      })
      .catch(function(error) {
        commit('error', error.response.data[0]);
        _response = false;
      });
  } catch (e) {
    commit('error', e.message);
  } finally {
    console.log('end request');
  }
  return _response;
}

export async function setupName({ commit }, data) {
  let userType = data.userIsAparent ? 'parent' : 'child';
  let url = `/${userType}/${data.userId}/name_setup/`;
  await Vue.axios({
    method: 'POST',
    url: url,
    data: {
      name: data.name,
      last_name: data.last_name,
      birthdate: data.birth_date,
    },
  })
    .then((response) => {
      commit('UpdateUserName', response.data);
    })
    .catch((error) => {
      commit('error', error.message);
    });
}

export async function getNotifications({ commit }, data) {
  let userType = data.userIsAparent ? 'parent' : 'child';
  let url = `/${userType}/${data.userId}/notifications/`;
  await Vue.axios({
    method: 'GET',
    url: url,
  })
    .then((response) => {
      commit('updateNotifications', response.data);
    })
    .catch((error) => {
      commit('error', error.message);
    });
}

export async function DeleteChild({ commit }, childId) {
  await Vue.axios({
    method: 'DELETE',
    url: `/child/${childId}/`,
  })
    .then((response) => {
      console.log(response);
    })
    .catch((error) => {
      commit('error', error.message);
    });
}

export async function fetchChildInfo({ commit }, childId) {
  await Vue.axios({
    method: 'GET',
    url: `/child/${childId}/`,
  })
    .then((response) => {
      commit('saveChildProfile', response.data);
    })
    .catch((error) => {
      commit('error', error.message);
    });
}

export async function deleteChildInfo({ commit }, childId) {
  await Vue.axios({
    method: 'DELETE',
    url: `/child/${childId}/`,
  })
    .then(() => {
      // commit("saveChildProfile", response.data);
    })
    .catch((error) => {
      commit('error', error.message);
    });
}

export async function updateChildInfo({ commit }, data) {
  await Vue.axios({
    method: 'PUT',
    url: `/child/${data.childId}/`,
    data: {
      name: data.name,
      last_name: data.last_name,
      age: data.age,
    },
  })
    .then((response) => {
      commit('saveChildProfile', response.data);
    })
    .catch((error) => {
      commit('error', error.message);
    });
}

export async function fetchTimeZone({ commit }) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: `/timezone/`,
  })
    .then((response) => {
      commit('setTimeZoneList', response.data);
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function setTimeZone({ commit }, data) {
  await Vue.axios({
    method: 'POST',
    url: `/${data.userIsAparent ? 'parent' : 'child'}/${data.userId}/timezone_setup/`,
    data: {
      time_zone: data.time_zone + '',
    },
  })
    .then(() => {
      commit('cleanErrors');
    })
    .catch((error) => {
      commit('error', error);
    });
}

export async function GetTimeZone({ commit }, data) {
  await Vue.axios({
    method: 'GET',
    url: `/${data.userIsAparent ? 'parent' : 'child'}/${data.userId}/timezone_setup/`,
  })
    .then((response) => {
      commit('SetTimeZone', response.data);
    })
    .catch((error) => {
      commit('error', error.message);
    });
}

export async function fetchChildAvatar({ commit }, childId) {
  await Vue.axios({
    method: 'GET',
    url: `/child/${childId}/avatar_setup/`,
  })
    .then((response) => {
      commit('saveChildAvatar', response.data);
    })
    .catch((error) => {
      commit('error', error.message);
    });
}

export async function setChildAvatar({ commit }, data) {
  await Vue.axios({
    method: 'POST',
    url: `/child/${data.childId}/avatar_setup/`,
    data: {
      avatar: data.idAvatar,
    },
  })
    .then((response) => {
      console.log(response.data);
    })
    .catch((error) => {
      commit('error', error.message);
    });
}
